import { apiClient, getOne } from "./Api";

const MODULE = 'user';

export function getUser() {
	return getOne(MODULE);
}

export function getUserIdentity() {
	return getOne(MODULE);
}
